import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import { Constants } from "../constants";
import infoImage from "../../assets/icons/infoImage.svg";

export default class InfoImageUI extends Plugin {
    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add( "infoImage", locale => {

            const buttonView = new ButtonView( locale );

            buttonView.set( {
                label: editor.config.get("infoImage.toolbarLabel" ) || Constants.infoImage.fallbackToolbarLabel,
                withText: !editor.config.get("isIconEnabled" ),
                tooltip: !!editor.config.get("isIconEnabled" ),
                icon: editor.config.get("isIconEnabled" ) ? infoImage : undefined,
            } );

            this.listenTo( buttonView, "execute", () => editor.execute( "infoImage" ) );

            return buttonView;
        } );
    }
}